<template>
  <div>
    <a-modal v-model="visible" centered :title="getTitle" :width="1000" :mask-closable="false" :ok-button-props="{ props: { loading: loading } }" destroy-on-close @cancel="close">
      <template slot="footer">
        <a-button @click="visible = false"> 取消 </a-button>
        <a-button v-if="sourceId === null" :loading="loading" @click="onSubmit('next')"> 完成并创建下一个 </a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit"> 完成 </a-button>
      </template>

      <a-spin :spinning="spinning">
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
          <div class="task-form__main">
            <div class="task-form__left">
              <a-form-model-item label="名称" prop="name" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                <a-input v-model="form.name" />
              </a-form-model-item>
              <a-form-model-item label="描述" prop="description" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                <am-editor v-model="form.description" :content="form.description" :drag="true" height="400px" @change="descChange" />
              </a-form-model-item>
            </div>
            <div class="task-form__right">
              <div class="task-form__section">
                <h3 class="task-form__section-title">基本信息</h3>
                <a-form-model-item label="优先级" prop="priority">
                  <a-select v-model="form.priority" allow-clear placeholder="优先级">
                    <a-select-option v-for="(item, index) in taskPrioritys" :key="index" :value="item.value">
                      <a-tag :color="item.color"> {{ item.label }} </a-tag>
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="任务点" prop="point">
                  <a-input-number v-model="form.point" style="width: 100%" :min="0" :step="1" />
                </a-form-model-item>
                <a-form-model-item label="任务分类" prop="category">
                  <a-select v-model="form.category" placeholder="任务分类" allow-clear>
                    <a-select-option v-for="(item, index) in tagData" :key="index" :value="item.id">
                      <a-tag :color="item.color"> {{ item.name }} </a-tag>
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>

              <div class="task-form__section">
                <h3 class="task-form__section-title">处理信息</h3>
                <a-form-model-item label="处理人" prop="handlers">
                  <a-select v-model="form.handlers" mode="multiple" show-search :filter-option="utils.filterOption">
                    <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>

              <div class="task-form__section">
                <h3 class="task-form__section-title">计划时间</h3>
                <a-form-model-item label="计划开始时间" prop="pre_start_time">
                  <a-date-picker v-model="form.pre_start_time" :disabled-date="disabledStartDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="任务计划开始时间" />
                </a-form-model-item>
                <a-form-model-item label="计划结束时间" prop="pre_end_time">
                  <a-date-picker v-model="form.pre_end_time" :disabled-date="disabledEndDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="任务计划结束时间" />
                </a-form-model-item>
              </div>
            </div>
          </div>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { tagList } from '@/api/system/tag';
import { taskUpdate } from '@/api/project/task';
import { faultTaskAdd } from '@/api/event/fault';
import { hasUploadingImages } from '@/utils/utils';
import { taskPrioritys } from '@/utils/dictionary';

import dayjs from 'dayjs';
import AmEditor from '@/components/AmEditor/index';

export default {
  name: 'TaskEdit',
  components: { AmEditor },
  data() {
    return {
      loading: false,
      spinning: false,
      taskPrioritys,
      visible: false,
      tagData: [],
      sourceId: null,
      form: {
        name: null,
        point: null,
        handlers: [],
        pre_start_time: null,
        pre_end_time: null,
        requirement_id: null,
        description: null,
        category: null
      },
      rules: {
        name: [{ required: true, message: '任务标题不能为空', trigger: 'blur' }],
        priority: [{ required: true, message: '优先级不能为空', trigger: 'blur' }],
        handlers: [{ required: true, message: '处理人不能为空', trigger: 'blur' }],
        point: [{ required: true, message: 'TaskPoint不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    userData() {
      return this.utils.getUserData(0);
    },
    getTitle() {
      return this.sourceId !== null ? '编辑任务' : '添加任务';
    }
  },
  methods: {
    onOpen(params = {}) {
      this.visible = true;
      this.loading = false;
      this.getTagList();
      this.sourceId = params.id || null;
      this.form = {
        fault_id: params.fault_id || null,
        name: params.name || null,
        point: params.point || null,
        pre_start_time: params.pre_start_time === '' ? null : params.pre_start_time,
        pre_end_time: params.pre_end_time === '' ? null : params.pre_end_time,
        description: params.description || null,
        priority: params.priority || null,
        category: params.extra && params.extra.category ? params.extra.category : null,
        handlers: params.handlers ? params.handlers.map(item => item.id) : [],
        project_id: params.project ? params.project.id : null,
        objective: Array.isArray(params.objective) ? params.objective.map(item => (isNaN(item) ? item.id : item)) : []
      };
    },

    onSubmit(type) {
      if (hasUploadingImages(this.form.description)) {
        this.$message.warning('有图片正在上传中，请等待上传完成或去除上传中的图片再提交哦~');
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          const form = {
            ...this.form,
            extra: {
              category: this.form.category || null
            }
          };
          if (this.sourceId !== null) {
            taskUpdate({ task_id: this.sourceId, ...form })
              .then(() => {
                this.$message.success('任务修改成功');
                this.close();
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            faultTaskAdd({ ...form })
              .then(() => {
                this.$message.success('任务添加成功');
                if (type === 'next') {
                  this.onOpen({ fault_id: this.form.fault_id });
                } else {
                  this.close();
                }
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },

    descChange(content) {
      this.form.description = content;
    },

    getTagList() {
      tagList({ group_code: 'task_category_tag' }).then(res => {
        this.tagData = res.data.items;
      });
    },

    /**
     * 禁用开始日期的规则
     * @param {Dayjs} startValue - 选择的开始日期
     * @returns {boolean} - true表示禁用该日期，false表示可选
     *
     * 规则：
     * 1. 如果没有设置结束日期，则不限制开始日期
     * 2. 如果设置了结束日期，开始日期不能晚于结束日期
     */
    disabledStartDate(startValue) {
      const endValue = dayjs(this.form.pre_end_time);
      if (!startValue || !endValue.isValid()) {
        return false;
      }
      // 开始日期不能晚于结束日期
      return startValue.startOf('day').valueOf() > endValue.startOf('day').valueOf();
    },

    /**
     * 禁用结束日期的规则
     * @param {Dayjs} endValue - 选择的结束日期
     * @returns {boolean} - true表示禁用该日期，false表示可选
     *
     * 规则：
     * 1. 如果没有设置开始日期，则不限制结束日期
     * 2. 如果设置了开始日期，结束日期不能早于开始日期
     */
    disabledEndDate(endValue) {
      const startValue = dayjs(this.form.pre_start_time);
      if (!endValue || !startValue.isValid()) {
        return false;
      }
      // 结束日期不能早于开始日期
      return endValue.startOf('day').valueOf() < startValue.startOf('day').valueOf();
    },

    close() {
      this.$emit('ok');
      this.$refs.form.resetFields();
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.task-form {
  &__main {
    display: flex;
    gap: 12px;
  }

  &__left {
    flex: 1;
    min-width: 0;
  }

  &__right {
    width: 300px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    :deep(.ant-form-item-label) {
      label {
        font-size: 12px;
      }
    }
  }

  &__section {
    background: #fafafa;
    border-radius: 8px;
    padding: 8px;

    &-title {
      font-size: 12px;
      font-weight: 500;
      color: #262626;
      margin-bottom: 8px;
      padding-left: 4px;
      border-left: 2px solid #1890ff;
    }
  }
}

:deep(.ant-form-item) {
  margin-bottom: 8px !important;

  &:last-child {
    margin-bottom: 0 !important;
  }

  .ant-form-item-label {
    line-height: 32px;
    padding-bottom: 0;
    text-align: right;
  }

  .ant-form-item-control {
    line-height: 32px;
  }
}

:deep(.ant-select),
:deep(.ant-picker) {
  width: 100%;
}

:deep(.ant-modal-body) {
  padding: 16px;
  max-height: 680px;
  overflow-y: auto;
}
</style>
